import { Component, OnInit } from '@angular/core';
import { TutorService } from 'src/app/services/tutor.service';
import { Tutor } from 'src/app/models/tutor';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tutors',
  templateUrl: './tutors.component.html',
  styleUrls: ['./tutors.component.scss']
})
export class TutorsComponent implements OnInit {
  public breadcrumbLinks=[];
  public thisPage:string='Lecturers';
  public tutors:Tutor[];
  public tutorImagePath:string;
  public image:string='/assets/imgs/tutors-header.jpg';
  public title:string='Lecturers and Speakers';
  public blurb:string='Exclusive CPD content from our highly qualified industry experts.';

  constructor(
    private _tutors: TutorService
  ) {
    this.tutorImagePath=environment.apiEndpoint+'/storage/tutors/';
  }

  ngOnInit() {
    this._tutors.getTutors().subscribe(
      (res:any) => {
        this.tutors=res;
        this.tutors.forEach(tutor=>{
          if(!tutor.image) tutor.image='Central_Lecturers_960_Circles_default.png';
        });
      }
    );
  }

}
